import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  cancelCrashBetService, escapeCrashBetService, getAllRoundHistoryService,
  getMyBetsService, verifyProvableFairCrashService, getTopBetsService, placeBetCrashGameService, getPreviousRoundBetsService, getMyStatsService, getFreeBetsService, getCrashGameUnfinishedBetService
} from 'network/services/crashGame.service'
import { setCashoutAmount } from 'pixi-js-scripts/crash-game/gameManager'
import { appendCurrentBetsToMyBets, setCrashToaster, setCurrentPlacedBet, setPlacedBetsData, setPlacedCrashBetId, setPlacingOrCashoutLoading } from 'redux-store/redux/slices/crashGame.slice'
// import { openSuccessToaster } from 'utils/common-services/toaster.service'
import { APPEND_TYPES, CRASH_GAME_STATE, CRASH_TOASTER_STATES } from 'utils/constants/index'
import { divide, times } from 'number-precision'
import { getPrecision } from 'utils/common-functions/index'
import {
  assignUnfinishedBetsToPanels,
  clearCrashBetPanelState,
  forgetCrashBetPanel,
  getCrashUnfinishedRestoreEpoch,
  rememberCrashBetPanel
} from 'pages/NewCrashGame/utils/crashBetPanelMap'

export const placedBetCrashGame = createAsyncThunk('crash-game/place-bet-crash-game', async ({ payload, id }, thunkApi) => {
  try {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: true }))
    const res = await placeBetCrashGameService(payload)
    thunkApi.dispatch(setCrashToaster({
      type: CRASH_TOASTER_STATES.BET_PLACED,
      data: null
    }))
    thunkApi.dispatch(setPlacedCrashBetId({ id, betId: res.id, reset: false }))
    thunkApi.dispatch(setCurrentPlacedBet({ id, betDetails: res, reset: false }))
    rememberCrashBetPanel(res.id, id)
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return res
  } catch (error) {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const escapeCrashBet = createAsyncThunk('crash-game/player-escape-crashGame', async ({ betId, id, rate, escapeRate, multiplier, onSuccess }, thunkApi) => {
  try {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: true }))
    const currentRate = rate ?? escapeRate ?? multiplier
    const escapePayload = { betId }
    if (currentRate != null && !isNaN(+currentRate) && +currentRate > 0) {
      const numRate = +currentRate
      escapePayload.rate = numRate
      escapePayload.escapeRate = numRate
      escapePayload.multiplier = numRate
      escapePayload.currentRate = numRate
    }
    const res = await escapeCrashBetService(escapePayload)
    if (typeof onSuccess === 'function') {
      onSuccess()
    }
    const store = thunkApi.getState()
    const placedBets = store?.crashGame?.betHistoryData ?? []
    const updatedPlacedBets = placedBets.some((b) => b.id === res.id)
      ? placedBets.map((b) => (b.id === res.id ? { ...b, ...res } : b))
      : [...placedBets, res]
    thunkApi.dispatch(
      setPlacedBetsData(
        updatedPlacedBets.filter((bet) => bet.result !== BET_RESULT.CANCELLED)
      )
    )
    // if (res && currentRate != null && !isNaN(+currentRate) && +currentRate > 0) {
    //   const targetRate = +currentRate
    //   const currentBetObj = store?.crashGame?.currentPlacedBet?.[id]
    //   const betAmt = res.betAmount ?? currentBetObj?.betAmount ?? 1
    //   res.escapeRate = targetRate
    //   res.winningAmount = getPrecision(times(betAmt, targetRate), 2)
    // }
    if (store?.crashGame?.myBetsData) {
      const state = store?.crashGame
      const escapedBet = [res]
      const betExist = state?.myBetsData?.rows?.some(bet => bet?.id === escapedBet?.[0]?.id)
      if (!betExist) {
        const _multiplier = getPrecision(divide(res?.winningAmount ?? 0, res?.betAmount ?? 1), 2)
        setCashoutAmount(`$${getPrecision(res?.winningAmount, 2)}`, `${_multiplier}`)
        thunkApi.dispatch(setCrashToaster({
          type: CRASH_TOASTER_STATES.CASHOUT_WIN,
          data: {
            winningAmount: getPrecision(res?.winningAmount, 2),
            escapeRate: res?.escapeRate
          }
        }))
        // openSuccessToaster({ message: `You win Odds : ${res?.escapeRate} Coins :${res?.winningAmount.toFixed(2)}` })
      }
    }
    thunkApi.dispatch(appendCurrentBetsToMyBets({ type: APPEND_TYPES.ESCAPE, data: [res] }))
    thunkApi.dispatch(setPlacedCrashBetId({ id, betId: null, reset: false }))
    thunkApi.dispatch(setCurrentPlacedBet({ id, betDetails: null, reset: false }))
    forgetCrashBetPanel(betId)
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return res
  } catch (error) {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return thunkApi.rejectWithValue(error[0]?.description || error?.message || 'Error escaping bet')
  }
})

export const cancelCrashBet = createAsyncThunk('crash-game/cancel-bet-crash-game', async ({ id, betId }, thunkApi) => {
  try {
    if (!betId) return thunkApi.rejectWithValue('Missing betId')

    const res = await cancelCrashBetService({ betId })
    thunkApi.dispatch(setPlacedCrashBetId({ id, betId: null, reset: false }))
    thunkApi.dispatch(setCurrentPlacedBet({ id, betDetails: null, reset: false }))
    forgetCrashBetPanel(betId)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getCrashGameUnfinishedBet = createAsyncThunk('crash-game/unfinished-bet', async (_, thunkApi) => {
  try {
    const epochAtStart = getCrashUnfinishedRestoreEpoch()
    const res = await getCrashGameUnfinishedBetService()

    if (epochAtStart !== getCrashUnfinishedRestoreEpoch()) {
      return res
    }

    const unfinishedBets = res?.hasUnfinishedGame
      ? (res?.unfinishedGameBetDetails || [])
      : []

    if (!unfinishedBets.length) {
      return res
    }

    const roundState = String(res?.roundState ?? '')
    if (
      roundState !== CRASH_GAME_STATE.STARTED &&
      roundState !== CRASH_GAME_STATE.ON_HOLD
    ) {
      return res
    }

    const {
      placedCrashBetId = [null, null],
      currentPlacedBet = [null, null]
    } = thunkApi.getState()?.crashGame || {}

    const existingIds = new Set(
      (placedCrashBetId || []).filter(Boolean).map((id) => String(id))
    )
    const incomingIds = new Set(unfinishedBets.map((bet) => String(bet.id)))

    if (
      existingIds.size > 0 &&
      existingIds.size === incomingIds.size &&
      [...existingIds].every((id) => incomingIds.has(id))
    ) {
      return res
    }

    const existingPanels = [0, 1].map((index) => {
      const betId = placedCrashBetId?.[index]
      if (!betId) return null
      if (currentPlacedBet?.[index]?.id != null &&
        String(currentPlacedBet[index].id) === String(betId)) {
        return currentPlacedBet[index]
      }
      return { id: betId }
    })

    const panels = assignUnfinishedBetsToPanels(unfinishedBets, existingPanels)

    if (epochAtStart !== getCrashUnfinishedRestoreEpoch()) {
      return res
    }

    panels.forEach((bet, index) => {
      if (!bet?.id) return
      if (placedCrashBetId?.[index] &&
        String(placedCrashBetId[index]) === String(bet.id)) {
        if (!currentPlacedBet?.[index]) {
          thunkApi.dispatch(setCurrentPlacedBet({ id: index, betDetails: bet, reset: false }))
        }
        return
      }
      if (placedCrashBetId?.[index]) return

      thunkApi.dispatch(setPlacedCrashBetId({ id: index, betId: bet.id, reset: false }))
      thunkApi.dispatch(setCurrentPlacedBet({ id: index, betDetails: bet, reset: false }))
    })

    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error?.[0]?.description || 'Failed to fetch unfinished bets')
  }
})

export const getAllRoundHistory = createAsyncThunk('crash-game/get-crash-game-history', async (_, thunkApi) => {
  try {
    const res = await getAllRoundHistoryService()
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMyBets = createAsyncThunk('crash-game/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getFreeBetDetail = createAsyncThunk('system/free-bet-details', async (params, thunkApi) => {
  try {
    const res = await getFreeBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMyStats = createAsyncThunk('crash-game/my-stats', async (params, thunkApi) => {
  try {
    const res = await getMyStatsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMyBetsPaginated = createAsyncThunk('crash-game/myBets-paginated', async (params, thunkApi) => {
  try {
    const res = await getMyBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getPreviousRoundBets = createAsyncThunk('crash-game/previous-round-placed-bets', async (params, thunkApi) => {
  try {
    const res = await getPreviousRoundBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const verifyProvableFairCrash = createAsyncThunk('crash-game/check-provable-fair', async ({ payload }, thunkApi) => {
  try {
    const res = await verifyProvableFairCrashService(payload)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getTopBets = createAsyncThunk('crash-game/topBets', async (params, thunkApi) => {
  try {
    const res = await getTopBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export { clearCrashBetPanelState as clearCrashBetPanelMap }
